import Control from "./Control.js"

export default class PanelControl extends Control {
  constructor(props, context) {
    super(props, context)
  }

  static get contextTypes() {
    return super.contextTypes
  }

  get propsList() {
    const { panel, ...props } = super.propsList
    return props
  }

  get panel() {
    return this.plugin.refs[this.props.panel]
  }

  onClick() {
    this.panel.toggle()
  }

  onKeyDown(event) {
    this.panel.onKeyDown(event)
  }
}
